import { snapshot } from 'valtio'
import { editableArea } from '../editableArea'

export function getEditableArea(immutable: boolean = true) {
  return immutable ? snapshot(editableArea.area) : editableArea.area
}
